import React, { useEffect } from "react";
import "./UpdateNotification.css";

const formatReleaseDate = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    const text = d.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",  
      hour12: false,
    });
    return `${text} IST`;
  } catch {
    return "";
  }
};


export default function ReleaseNotesModal({ open, onClose, notes }) {
  const releaseNotes = Array.isArray(notes) ? notes : [];
  const visibleNotes = releaseNotes.slice(0, 2);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="release-notes-modal__backdrop"
      role="dialog"
      aria-modal="true"
      onClick={() => onClose?.()}
    >
      <div
        className="release-notes-modal__card"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="release-notes-modal__header">
          <h3 className="release-notes-modal__title">Release Notes</h3>
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={() => onClose?.()}
          >
            Close
          </button>
        </div>
        <div className="release-notes-modal__body custom-ak-scollbar">
          {releaseNotes.length === 0 ? (
            <p className="update-banner__sub">No release notes available.</p>
          ) : (
            visibleNotes.map((item) => (
              <div key={item.version} className="release-notes-item">
                <p className="release-notes-item__v">
                  Version {item.version}
                  {item.title ? ` — ${item.title}` : ""}
                </p>
                <p className="release-notes-item__meta">
                  {formatReleaseDate(item.releasedAt)}
                </p>
                {item.description ? (
                  <p className="release-notes-item__desc">{item.description}</p>
                ) : null}
                {Array.isArray(item.features) && item.features.length > 0 ? (
                  <ul className="update-banner__list">
                    {item.features.map((f) => (
                      <li key={`${item.version}:${f}`}>{f}</li>
                    ))}
                  </ul>
                ) : null}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
